import { render, staticRenderFns } from "./MoviesTwelve.vue?vue&type=template&id=97258f84&scoped=true&"
import script from "./MoviesTwelve.vue?vue&type=script&lang=js&"
export * from "./MoviesTwelve.vue?vue&type=script&lang=js&"
import style0 from "./MoviesTwelve.vue?vue&type=style&index=0&id=97258f84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97258f84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
